import React from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import PrivateRoute from "../components/PrivateRoute";
import UserEditor from "../views/admin/UserEditor";
import UserList from "../views/admin/UsersList";
import TenantEditor from "../views/admin/TenantEditor";
import TenantHierarchy from "../views/admin/TenantHierarchy";
import ProductsList from "../views/admin/ProductsList";
import UserPicker from "../views/admin/UserPicker";

import roles from "../auth/roles";

const AdminRouter = () => {

  let { path } = useRouteMatch();

  return (
    <Switch>
      <PrivateRoute
        key="dashboard"
        path={`${path}/dashboard`}
        exact
        component={() => <h3>Admin dashboard here... work in progress!</h3>}
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="listusers"
        path={`${path}/users`}
        exact
        component={UserList}
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="adduser"
        path={`${path}/add-user`}
        component={UserEditor}
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="edituser"
        path={`${path}/users/:id`}
        edit
        component={UserEditor}
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="addtenant"
        path={`${path}/add-tenant`}
        component={TenantEditor}
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="addFiliale"
        path={`${path}/add-tenant-child/:parent`}
        edit
        component={TenantEditor}
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="addSeller"
        path={`${path}/add-tenant-user/:role/:parent`}
        edit
        component={UserPicker}
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="edittenant"
        path={`${path}/tenants/:id`}
        edit
        component={TenantEditor}
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="tenanthierarch"
        path={`${path}/tenants-hierarchy/:id`}
        edit
        component={TenantHierarchy}
        roles={[roles.ADMIN]}
      />
      <PrivateRoute
        key="listproducts"
        path={`${path}/products`}
        isBackOffice
        component={ProductsList}
        exact
        roles={[roles.ADMIN]}
      />
    </Switch>
  );
};

export default AdminRouter;
